import { Button } from '@design/components/button/Button';
import { useTranslation } from 'react-i18next';

export interface InsightCopyBtnProps {
  onClick: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export const InsightCopyBtn = ({
  onClick,
  className,
  isLoading,
  disabled,
}: InsightCopyBtnProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <Button
      iconName="Copy"
      label={t('widget:copyInsight')}
      onClick={onClick}
      variant="empty"
      size="xsmall"
      className={className}
      isLoading={isLoading}
      disabled={disabled}
      data-testid="copy-insight"
    />
  );
};
